import "./index_module.css";
var index_module_default = { "recordingBanner": "recordingBanner_36cc2", "bannerTitle": "bannerTitle_36cc2", "timer": "timer_36cc2", "bannerDescription": "bannerDescription_36cc2", "debugId": "debugId_36cc2" };
export {
  index_module_default as default
};
